export const COL_USERS = "users";
export const COL_POSTS = "posts";

// user
export const DOC_NICKNAME = "nickname";
export const DOC_EMAIL = "email";

// post
export const DOC_UID = "uid";
export const DOC_NAME = "name";
export const DOC_TYPE = "type";
export const DOC_ADDRESS = "address";
export const DOC_BATHROOMS = "bathrooms";
export const DOC_DESCRIPTION = "description";
export const DOC_DISCOUNT_PRICE = "discountedPrice";
export const DOC_REG_PRICE = "regularPrice";
export const DOC_FURNISHED = "furnished";
export const DOC_LAT = "latitude";
export const DOC_LON = "longitude";
export const DOC_OFFER = "offer";
export const DOC_PARKING = "parking";
export const DOC_IMAGES = "images";
export const DOC_CREATEDATE = "createDate";
